import { EditorSide } from '@/shared/types/configurator';
import { FC } from 'react';
import { SectionProps, SectionSideProps } from '../../types/section.types';
import { FrontSection } from '../front-section/front-section';
import { SideSection } from '../side-section/side-section';
import { TopSection } from '../top-section/top-section';

const sectionSides: Record<EditorSide, FC<SectionSideProps>> = {
	[EditorSide.FRONT]: FrontSection,
	[EditorSide.SIDE]: SideSection,
	[EditorSide.TOP]: TopSection,
};

export const Section = ({ side, ...props }: SectionProps) => {
	const SectionComponent = sectionSides[side];

	return <SectionComponent {...props} />;
};
